/* Library */
import React, { Component } from 'react';
import serverClientUtil from '../../../../utils/serverClientUtil';
import TextInput from './../../../../components/ZUILib/TextInput';
import LinkR from './../../../../components/ZUILib/Link';
import InputButton from './../../../../components/ZUILib/InputButton';
import CheckBox from './../../../../components/ZUILib/CheckBox';
import Warning from '../../../../components/Warning';
import commonUtil from '../../../../utils/commonUtil';
import errorLables from '../../../../utils/errors/LP_GR_error.json';

const channel = commonUtil.getChannel();
class Login extends Component {
  constructor(props) {
    super(props);
    this.errorcode = '';
    this.warningMessage = '';
  }
  state = {
    showRemeberMe: false,
    errorMessage: '',
  }
  loginForm = {
    login: '',
    password: '',
    autoLoginCheckbox: '',
  }
  isValueAvailable = (str) => {
    if (str && str.trim()) {
      return true;
    }
    return false;
  }
  validate = () => {
    const emailValidationRules = [
      { functionRef: this.isValueAvailable, funcData: [this.login.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.email.required') },
      { functionRef: commonUtil.validateEmail, funcData: [this.login.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.email.invalid') },
    ];

    const passwordValidationRiles = [
      { functionRef: this.isValueAvailable, funcData: [this.password.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.password.required') },
      { functionRef: commonUtil.validatePassword, funcData: [this.password.getValue(), 8], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.password.invalid') },
    ];

    const isLoginValid = commonUtil.validateTextInput(emailValidationRules, this.login, null);
    const isPasswordValid = commonUtil.validateTextInput(passwordValidationRiles, this.password, null);

    if (isLoginValid && isPasswordValid) {
      this.loginForm.login = this.login.getValue();
      this.loginForm.password = this.password.getValue();
      this.loginForm.autoLoginCheckbox = this.userAutoLogingChk.isChecked() ? 'true' : 'false';
    }

    const { login, password } = this.loginForm;
    if (login && password) {
      return true;
    }
    return false;
  }

  handleLoginOnEnter = (e) => {
    if (e.key === 'Enter' && this.validate()) {
      this.handleUserLogin();
    }
  }

  handleUserLogin = () => {
    if (this.validate() && this.props._handleUserLogin) {
      this.props._handleUserLogin(this.loginForm);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', () => { });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.user.loaded === true && nextProps.user.data.result.status.status === 'success') {
      this.warning.setMessage('');
    } else if (nextProps.user.loaded === true && nextProps.user.data.result.status.errorMessage) {
      this.warning.setMessage(nextProps.user.data.result.status.errorMessage);
    } else if (nextProps.user.data.result.errorCode) {
      this.errorcode = nextProps.user.data.result.errorCode ? `${nextProps.user.data.result.errorCode} 'error found'` : null;
    }
  }

  toggleRemeberMeMessage = () => {
    if (this.autoLoginTooltipsignInWeb.style.display === 'none') {
      this.autoLoginTooltipsignInWeb.style.display = 'block';
    } else {
      this.autoLoginTooltipsignInWeb.style.display = 'none';
    }
  }

  render() {
    const { lables } = this.props;
    const TableGift4 = {
      type: 'button',
      value: 'Entrar',
      autoFocus: false,
      style: (channel === 'web') ? 'btnPrimary btnExtraLarge' : 'btnPrimary size-Full',
      onClickHandler: this.handleUserLogin,
    };
    const rememberMeCheckBoxConfig = {
      displayName: commonUtil.getLabel(lables.createLogin, 'login.keep.me.login'),
      id: 'checkbox1',
      name: '',
      value: '',
      disabled: '',
    };

    const linkJSON2 = {
      text: 'Link Text',
      children: commonUtil.getLabel(lables.createLogin, 'forgot.password.link'),
      areaLabel: 'abc',
      href: serverClientUtil.getLPFullURL() + '/users/forgotPassword?login=',
      tabindex: -1,
      class: 'intoMesaLabel',
    };

    return (
      <React.Fragment>
        <div id="intoMesa" style={{ display: 'block' }}>
          <p>ENTRAR A MI MESA <span className="backButton" onClick={this.props.toggleRegister} autoFocus="false">
            <i className="icon-flecha_gruesa_izq" />Regresar</span></p>
          <div>
            <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
          </div>
          <div className="clearfix" />
          <form>
            <div className="formBlock">
              <div className="materialStyle">
                <TextInput
                  className="inputMaterial emailType"
                  labelClassName="placeHolderMaterial"
                  htmlId="email"
                  label={commonUtil.getLabel(lables.createLogin, 'login.user.name')}
                  required="true"
                  maxlength="100"
                  ref={login => this.login = login}
                  onKeyPress={this.handleLoginOnEnter}
                />
              </div>
            </div>
            <div className="formBlock">
              <div className="materialStyle">
                <TextInput
                  className="inputMaterial"
                  labelClassName="placeHolderMaterial"
                  htmlId="password"
                  label={commonUtil.getLabel(lables.createLogin, 'login.user.password')}
                  required="true"
                  type="password"
                  ref={password => this.password = password}
                  onKeyPress={this.handleLoginOnEnter}
                />
              </div>
            </div>
            <InputButton buttonAttr={TableGift4} />
            <div className={channel === 'web' ? 'row' : ''}>
              {/* eslint-disable */}
              <div className="col-md-12 p-l-20 homelogin-box">
                <CheckBox displayName={rememberMeCheckBoxConfig.displayName} id={rememberMeCheckBoxConfig.accountSession} ref={(e) => { this.userAutoLogingChk = e; }}>
                  <a className={channel === 'web' ? 'float-right' : ''} onClick={this.toggleRemeberMeMessage}>{commonUtil.getLabel(lables.createLogin, 'login.detalla.link')}<i className="icon-caret_down" /></a>
                  <div className="homeSessionContainer" style={{ display: 'none' }} ref={(e) => { this.autoLoginTooltipsignInWeb = e; }}>
                <div className="rememberMeContent">
                  <p >{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.header.content')} <i className="icon-tache closeContainer" onClick={this.toggleRemeberMeMessage} /></p>
                  <hr />
                  <p >{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.content1')}</p>
                  <p >{commonUtil.getLabel(lables.createLogin, 'createLogin.rememberme.content2')}</p>
                </div>
              </div>
                </CheckBox>
              </div>
            </div>
            <p className="forgotPassword">
              <LinkR linkJSON={linkJSON2} href={linkJSON2.href}>{linkJSON2.children}</LinkR>
            </p>
          </form>
        </div>
      </React.Fragment>
    );
  }
}
export default Login;
